import "./products.scss";
const ProductsScreen = () => {
  return <div className="products">Products</div>;
};

export default ProductsScreen;
